import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { format } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { Dataset } from './dataset';
import { SqlAnalyticsEndpointLinkedService } from '../linkedservice/sql-analytics-endpoint.linkedservice';

@Metamodel.model({
    name: ModelConstants.sqlAnalyticsEndpointDataset,
    display: [
        format(shellStringResources.ModelName_DatasetTemplate, shellStringResources.SqlAnalyticsEndpoint_DisplayText),
        format(shellStringResources.ModelName_DatasetsTemplate, shellStringResources.SqlAnalyticsEndpoint_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SqlAnalyticsEndpointLinkedService.MODEL
        }
    }
})
export class SqlAnalyticsEndpointDataset extends Dataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
        this.isV2 = true;
    }
}
